module.exports = __webpack_public_path__ + "static/media/right.a548fa4a.svg";